import { Component, Object3D } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { GlobalEvents } from '../core/global-events.js';
import { ObjectiveType } from '../core/game-manager.js';
import { wlUtils } from '@sorskoot/wonderland-components';

export class ActivateFinalStep extends Component {
    static TypeName = 'activate-final-step';

    @property.object({ required: true })
    finalStep!: Object3D;

    private _cupFound: boolean = false;
    private _musicBoxFound: boolean = false;

    start(): void {
        wlUtils.setActive(this.finalStep, false);
    }

    onActivate(): void {
        GlobalEvents.instance.objectiveCompleted.add(
            this._onObjectiveCompleted,
            this
        );
    }

    private _onObjectiveCompleted(objective: ObjectiveType) {
        // Prevent multiple activations if both objectives are already found
        if (this._cupFound && this._musicBoxFound) {
            return;
        }

        if (objective === ObjectiveType.FindCup) {
            this._cupFound = true;
        } else if (objective === ObjectiveType.FindMusicBoxKey) {
            this._musicBoxFound = true;
        }

        if (this._cupFound && this._musicBoxFound) {
            wlUtils.setActive(this.finalStep, true);
        }
    }
}
